var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "facebook",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_3",
    "data-name": "Rect\\xE1ngulo 3",
    width: 20.36,
    height: 20.37,
    transform: "translate(0 0)",
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_19",
    "data-name": "Rect\\xE1ngulo 19",
    width: 24,
    height: 24,
    fill: "#1c1c1c",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5",
    "data-name": "Grupo 5",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4",
    "data-name": "Grupo 4",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1",
    "data-name": "Trazado 1",
    d: "M17.377,2.983a10.172,10.172,0,0,0-14.393,0A10.187,10.187,0,0,0,14.076,19.6a10.408,10.408,0,0,0,3.3-2.213,10.183,10.183,0,0,0,0-14.4M11.43,12.76h1.63a1.25,1.25,0,0,0,0-2.5H11.43V7.77a.752.752,0,0,1,.75-.75h1.2a1.25,1.25,0,0,0,1.25-1.25,1.237,1.237,0,0,0-1.25-1.25h-1.7A2.753,2.753,0,0,0,8.93,7.27v2.99H7.31a1.25,1.25,0,0,0,0,2.5H8.93v6.025A8.693,8.693,0,0,1,4.037,4.047,8.69,8.69,0,0,1,18.21,13.5a8.765,8.765,0,0,1-1.886,2.82,8.63,8.63,0,0,1-4.894,2.462Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d113bd82f0ed64ed2ab449a86a11f5cd.svg";
export { ForwardRef as ReactComponent };